import EventScorekeepingEdit from '@/screens/EventScorekeepingEdit';

export default function PrivateTabsOrganizationEventScorekeepingIndexRoute() {
  return <EventScorekeepingEdit basePath="/organization/event" />;
}
